import Link from "next/link";

export default function ExamplesShowcase() {
  return (
    <div className="bg-gray-800 rounded-lg p-6 mb-8 text-center">
      <h3 className="text-xl font-semibold text-white mb-4">
        Want to see examples built with Peerquik?
      </h3>
      <p className="text-md text-gray-300 mb-4">
        Check out these projects powered by our boilerplate:
      </p>
      <div className="flex flex-wrap justify-center gap-4">
        <span className="text-md">
          <strong>B2C Marketplace:</strong>{" "}
          <Link
            href="https://beunderwater.com"
            className="underline text-cyan-400 hover:text-cyan-500"
          >
            BeUnderwater
          </Link>{" "}
          &{" "}
          <Link
            href="https://scubareputation.com"
            className="underline text-cyan-400 hover:text-cyan-500"
          >
            Scuba Reputation
          </Link>
        </span>
        <span className="text-md">
          <strong>Basic:</strong>{" "}
          <Link
            href="https://seozast.com"
            className="underline text-cyan-400 hover:text-cyan-500"
          >
            SEOZast
          </Link>
        </span>
      </div>
    </div>
  );
}